import { useEffect, useState } from "react";
import ResultTable from "src/components/IncomeTable/ResultTable";

import { useInfo } from "src/hooks/useData";
import MapChart from "src/components/MapChart";
import CompositeTable from "./Report/CompositeTable";
import { useFullscreen } from "src/hooks/useFullScreen";
import SpendChart from "./SpendChart";

import { ScenarioSettings, SelectedColumn } from "src/types";
import ChartModal from "./ChartModal";
import TaxStatusTable from "./IncomeTable/TaxStatusTable";
import SourceTable from "./IncomeTable/SourceTable";
import PersonTable from "./IncomeTable/PersonTable";
import ScenarioHeader from "./IncomeTable/ScenarioHeader/ScenarioHeader";
import SpendingTable from "./Spending/SpendingTable";
import GroupedChart from "./Charts/GroupedChart";
import ByIncomeChart from "./Charts/ByIncomeChart";
import ByPersonChart from "./Charts/ByPersonChart";
import { ScenarioProvider } from "src/hooks/useScenario";

const Map = ({
  settings,
  setMapScroll,
}: {
  settings: ScenarioSettings;
  setMapScroll: any;
}) => {
  const { data } = useInfo();
  const [selectedYear, setSelectedYear] = useState(0);
  const { isFullscreen } = useFullscreen();
  const [selectedColumn, setSelectedColumn] = useState<SelectedColumn>({
    id: 0,
    type: "none",
  });

  // update scroll position on scroll
  useEffect(() => {
    const handleScroll = () => {
      setMapScroll(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const shownTable = data.liveSettings.mapType;

  const Chart = (() => {
    // return () => <div></div>;
    if (shownTable == "spending") {
      return SpendChart;
    } else if (shownTable == "by income type") {
      return ByIncomeChart;
    } else if (shownTable == "by person") {
      return ByPersonChart;
    } else if (shownTable == "by tax status") {
      return GroupedChart;
    } else {
      return MapChart;
    }
  })();

  const getTable = (shownTable: string) => {
    if (shownTable === "composite") {
      return CompositeTable;
    } else if (shownTable === "result") {
      return ResultTable;
    } else if (shownTable === "by tax status") {
      return TaxStatusTable;
    } else if (shownTable === "by income type") {
      return SourceTable;
    } else if (shownTable === "by person") {
      return PersonTable;
    } else if (shownTable === "spending") {
      return SpendingTable;
    } else {
      return ResultTable;
    }
  };
  const Table = getTable(shownTable);

  return (
    <ScenarioProvider scenario={settings} client={data}>
      <div className="pb-32 ">
        <div
          className={`sticky z-50 ${isFullscreen ? "top-0" : "top-[100px]"}`}
        >
          <ScenarioHeader client={data} settings={settings} />
          <div
            className={`flex ${!settings.chartFirst ? "flex-col" : "flex-col-reverse"}`}
          >
            <Table
              client={data}
              scenario={settings}
              settings={settings}
              selectedYear={selectedYear}
              setSelectedYear={setSelectedYear}
              selectedColumn={selectedColumn}
              setSelectedColumn={setSelectedColumn}
            />
            <div className="my-3 bg-white">
              <div className="flex justify-end p-3 z-100000">
                <ChartModal
                  children={
                    <div>
                      <div className="flex justify-end gap-3"></div>
                      <Chart settings={settings} client={data} />
                    </div>
                  }
                />
              </div>
              <div className="mt-[-50px]">
                <Chart settings={settings} client={data} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ScenarioProvider>
  );
};

export default Map;
